import NOMAD_API_CONSTANTS from '@/constants/nomad-api';
import { jobCategoryDisciplineByDisciplineType } from '@/features/job-category-page/mappers/job-category-discipline-by-discipline-type.mapper';
import { GetJobCategoryPageJobsResponse } from '@/features/job-category-page/services/public-jobs.service';
import { JobCategoryPage } from '@/features/job-category-page/types';
import { isNurse } from '@/utils/discipline-utils';
import { JobSearchQuery } from '@/utils/route-utils';

export const jobSearchQueryFromJobCategoryPage = (
  page: Partial<JobCategoryPage>
): JobSearchQuery => ({
  ...NOMAD_API_CONSTANTS.DEFAULT_JOB_SEARCH_QUERY,
  discipline:
    page.discipline?.apiId ||
    jobCategoryDisciplineByDisciplineType(page.disciplineType),
  specialty: page.specialty?.title || undefined,
  locations: page.region?.title || undefined,
});

export const jobSearchQueryFromJobCategoryPageAndRelatedJobsLevel = (
  { discipline, disciplineType, specialty }: JobCategoryPage,
  relatedJobsLevel: GetJobCategoryPageJobsResponse['relatedJobsLevel']
): JobSearchQuery => {
  if (relatedJobsLevel === 'specialty') {
    return {
      discipline:
        discipline?.apiId ||
        jobCategoryDisciplineByDisciplineType(disciplineType),
      specialty: specialty?.title,
    };
  }

  if (relatedJobsLevel === 'discipline') {
    return {
      discipline:
        discipline?.apiId ||
        jobCategoryDisciplineByDisciplineType(disciplineType),
    };
  }

  if (isNurse(disciplineType)) {
    return {
      discipline: NOMAD_API_CONSTANTS.NURSE_API_ID,
    };
  }

  return {};
};
